import { AccountId, ApiResponse, SuitabilityQuestionnaire, SuitabilityQuestionnaireRequest } from '@arrived/models';

import { api } from './api';
import { unwrapApiResponse } from './utils';

export const getUserAccountSuitabilityQuestionnaire = async (accountId: AccountId) => {
  const response = await api.get<ApiResponse<SuitabilityQuestionnaire>>(
    `/users/accounts/${accountId}/suitability-questionnaire`
  );

  return unwrapApiResponse(response.data);
};

export const postUserAccountSuitabilityQuestionnaire = async (request: SuitabilityQuestionnaireRequest) => {
  const response = await api.post<ApiResponse<SuitabilityQuestionnaire>>(
    `/users/accounts/${request.accountId}/suitability-questionnaire`,
    request
  );

  return unwrapApiResponse(response.data);
};

export const putUserAccountSuitabilityQuestionnaire = async (request: SuitabilityQuestionnaireRequest) => {
  const response = await api.put<ApiResponse<SuitabilityQuestionnaire>>(
    `/users/accounts/${request.accountId}/suitability-questionnaire`,
    request
  );

  return unwrapApiResponse(response.data);
};

export const deleteUserAccountSuitabilityQuestionnaire = async (accountId: AccountId) => {
  const response = await api.delete<ApiResponse<SuitabilityQuestionnaire>>(
    `/users/accounts/${accountId}/suitability-questionnaire`
  );

  return unwrapApiResponse(response.data);
};
